import $ from "jquery";
import "popper.js"; // Bootstrap requires this
import "bootstrap";
import "fslightbox";
// Can import modules as needed
// ex. import 'bootstrap/js/dist/dropdown';
// import "./scss/style.scss"; // This is now being imported in the webpack.config file 

// # ---------------------------------------------------------------
// # Custom Methods...
(function ($) {
	$(function () {
		 // console.log("test");

		 // Single Project Carousel Customizations
		 var carouselWidth = $("#projectPhotoSlider .carousel-inner")[0].scrollWidth;
		 var cardWidth = $("#projectPhotoSlider .carousel-item").width();
		 var scrollPosition = 0;

		 $("#projectPhotoSlider .carousel-control-next").on("click", function () {
			if (scrollPosition < (carouselWidth - cardWidth * 2)) { //check if you can go any further
			  scrollPosition += cardWidth;  //update scroll position
			  $("#projectPhotoSlider .carousel-inner").animate({ scrollLeft: scrollPosition },600); //scroll left
			}
		  });

		  $("#projectPhotoSlider .carousel-control-prev").on("click", function () {
			if (scrollPosition > 0) {
			  scrollPosition -= cardWidth;
			  $("#projectPhotoSlider .carousel-inner").animate(
				{ scrollLeft: scrollPosition },
				600
			  );
			}
		  });

		  var multipleCardCarousel = document.querySelector(
			"#projectPhotoSlider"
		  );
		  if (window.matchMedia("(min-width: 768px)").matches) {
			//rest of the code
			var carousel = new bootstrap.Carousel(multipleCardCarousel, {
			  interval: false,
			  wrap: false
			});
		  } else {
			$(multipleCardCarousel).addClass("slide");
		  }

	});
})($);